import { InputAdornment, MenuItem, Select, TextField } from "@mui/material";
import axios from "axios";
import { useState } from "react";
import { alert } from "src/services/alert";
import { asyncRequest } from "src/services/network";
import FormDialog from "src/components/common/FormDialog";
import FormItem from "src/components/form-item/FormItem";

const ChangeMerchantVersionDialog = ({ merchant, open, onClose, onFinish }) => {
  const [form, setForm] = useState({
    version: merchant.version,
  });

  function handleIptChange(ki, val) {
    // console.log(ki, val);
    setForm({
      ...form,
      [ki]: val,
    });
  }

  async function handleDialogConfirm() {
    console.log(form)
    if (form.version == merchant.version) return alert("版本没有变化");

    const { msg } = await asyncRequest({
      path: "/merchant/changeVersion",
      data: {
        ...form,
        mid: merchant.mid,
      },
    });

    alert(msg, "success");
    onFinish();
  }

  return (
    <FormDialog title="修改版本" open={open} onClose={onClose} onConfirm={handleDialogConfirm}>
      <FormItem title="当前版本">
        <TextField fullWidth disabled value={merchant.version} size="small" />
      </FormItem>

      <FormItem title="新版本" size="small">
        <Select value={form.version} onChange={e => handleIptChange('version', e.target.value)}>
          <MenuItem value={1}>1.0</MenuItem>
          <MenuItem value={2}>2.0</MenuItem>
          <MenuItem value={3}>3.0</MenuItem>
        </Select>
      </FormItem>

      <FormItem title="备注">
        <TextField fullWidth value={form.remark} size="small"  onChange={e => handleIptChange('remark', e.target.value)} />
      </FormItem>
    </FormDialog>
  );
};

export default ChangeMerchantVersionDialog;
